/// <amd-module name="SuiteCommerce.SizeChart.Common.DependencyProvider"/>
define("SuiteCommerce.SizeChart.Common.DependencyProvider", ["require", "exports", "underscore", "Utils"], function (require, exports, _, UtilsModule) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Utils = getDependency(UtilsModule);
    function getDependency(module) {
        if (isTranspiledModule(module)) {
            return module[Object.keys(module)[0]];
        }
        return module;
    }
    function isTranspiledModule(module) {
        var moduleKeys = Object.keys(module);
        return !_.isFunction(module) && moduleKeys.length === 1;
    }
});
